import { render } from "./SortOrder.vue?vue&type=template&id=7c074774&scoped=true"
import script from "./SortOrder.vue?vue&type=script&lang=js"
export * from "./SortOrder.vue?vue&type=script&lang=js"

import "./SortOrder.vue?vue&type=style&index=0&id=7c074774&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c074774"],['__file',"src/views/ProductVariants/SortOrder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c074774"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c074774', __exports__)) {
    api.reload('7c074774', __exports__)
  }
  
  module.hot.accept("./SortOrder.vue?vue&type=template&id=7c074774&scoped=true", () => {
    api.rerender('7c074774', render)
  })

}


export default __exports__